import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/brownsville")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Marine Canvas in Brownsville, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, sail shades and marine canvas for Brownsville, South Padre & Cameron County. Free quotes — +1 (830) 390-9588.",
      keywords: "pergola covers Brownsville, pergola covers Texas, custom pergola covers Brownsville, aluminum pergola covers Brownsville",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Brownsville, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Brownsville and Cameron County.",
    }),
    scripts: cityHeadScripts("Brownsville", "Cameron County"),
  }),
  component: () => <CityHomePage city="Brownsville" region="Cameron County" />,
});
